import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { showSnack } from '../actions/snackbarActions';
import { closeModal, MODAL_TYPES } from './modalActions';
import { marginProductSelector } from '../selectors/marginProductSelectors';
import { marginAccountSelector } from '../selectors/marginSelectors';
import { positionSelector } from '../selectors/positionSelectors';
import { change } from 'redux-form';
import BigNumber from 'bignumber.js';
export var TRANSFER_ASSETS_REQUESTED = 'TRANSFER_ASSETS_REQUESTED';
export var TRANSFER_ASSETS_SUCCESS = 'TRANSFER_ASSETS_SUCCESS';
export var TRANSFER_ASSETS_ERROR = 'TRANSFER_ASSETS_ERROR';
export var setMaxValue = function setMaxValue() {
  return function (dispatch, getState) {
    var state = getState();
    var form = state.form;
    var formObj = form.marginTransferAssets || {
      values: {}
    };
    var marginAccount = marginAccountSelector(state);
    var isMarginContext = marginAccount.AccountId === Number(formObj.values.accountFrom);
    var products = void 0;
    var selectedAsset = void 0;
    if (isMarginContext) {
      products = marginProductSelector(state);
      selectedAsset = products.find(function (product) {
        return product.ProductId === Number(formObj.values.asset);
      });
    } else {
      products = positionSelector(state);
      selectedAsset = products[formObj.values.asset];
    }
    var amount = 0;
    if (selectedAsset) {
      if (isMarginContext) {
        amount = marginAccount.AccountId === Number(formObj.values.accountFrom) ? selectedAsset.MarginAmount : selectedAsset.StandardAmount;
        amount = amount - selectedAsset.Hold;
      } else {
        amount = new BigNumber(selectedAsset.Amount).minus(selectedAsset.Hold).toNumber();
      }
      if (amount < 0) amount = 0;
    }
    dispatch(change('marginTransferAssets', 'amount', amount));
  };
};
export var transferAssets = function transferAssets(data) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, _state$user$userInfo, OMSId, UserId, accounts, accountFrom, accountTo, AssetAccountId, TransferToMarginAccount, payload, responseObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestTransferAssets());
              state = getState();
              _state$user$userInfo = state.user.userInfo, OMSId = _state$user$userInfo.OMSId, UserId = _state$user$userInfo.UserId;
              accounts = state.user.accounts;
              accountFrom = accounts.find(function (acc) {
                return acc.AccountId === Number(data.accountFrom);
              });
              accountTo = accounts.find(function (acc) {
                return acc.AccountId === Number(data.accountTo);
              });
              AssetAccountId = void 0;
              if (accountFrom.AccountType === 'Asset') {
                AssetAccountId = accountFrom.AccountId;
              } else if (accountTo.AccountType === 'Asset') {
                AssetAccountId = accountTo.AccountId;
              }
              TransferToMarginAccount = void 0;
              if (accountFrom.AccountType === 'Asset' && accountTo.AccountType === 'MarginAsset') {
                TransferToMarginAccount = true;
              } else if (accountFrom.AccountType === 'MarginAsset' && accountTo.AccountType === 'Asset') {
                TransferToMarginAccount = false;
              }
              payload = {
                OMSId: OMSId,
                UserId: UserId,
                Amount: data.amount,
                AssetAccountId: AssetAccountId,
                TransferToMarginAccount: TransferToMarginAccount,
                ProductId: Number(data.asset)
              };
              _context.prev = 11;
              _context.next = 14;
              return dispatch(callAPI('TransferAssetsBetweenUserAssetAndMarginAccounts', payload));
            case 14:
              responseObj = _context.sent;
              if (responseObj.result) {
                dispatch(receiveTransferAssets());
                dispatch(closeModal(MODAL_TYPES.MARGIN_TRANSFER_ASSETS));
                dispatch(showSnack({
                  id: 'transferAssetsSuccess',
                  text: 'You made a Transfer',
                  type: 'success'
                }));
              } else {
                dispatch(receiveTransferAssetsError());
                dispatch(showSnack({
                  id: 'transferAssetsError',
                  text: responseObj.errormsg + ': ' + responseObj.detail,
                  type: 'warning'
                }));
              }
              _context.next = 23;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context['catch'](11);
              console.error('TransferAssetsBetweenUserAssetAndMarginAccounts error: ', _context.t0);
              dispatch(receiveTransferAssetsError());
              dispatch(showSnack({
                id: 'transferAssetsError',
                text: _context.t0.o,
                type: 'warning'
              }));
            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[11, 18]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var requestTransferAssets = function requestTransferAssets() {
  return {
    type: TRANSFER_ASSETS_REQUESTED
  };
};
export var receiveTransferAssets = function receiveTransferAssets() {
  return {
    type: TRANSFER_ASSETS_SUCCESS
  };
};
export var receiveTransferAssetsError = function receiveTransferAssetsError() {
  return {
    type: TRANSFER_ASSETS_ERROR
  };
};